export default __webpack_public_path__ + "static/media/en.c14d3d19.png";